import React,{useEffect, useState}from 'react'
import { Table,Space, message, Image, Button, } from 'antd';
import ModalDel from '../../cpn/ModalDel';
import Main from '../../cpn/Main';
import {useBnsGuiGeDelMutation,  useBnsGuiGeListQuery } from '../../store/BnsKeJiApi';
import ProjectSelect from '../../backend/project/ProjectSelect';
import SpecAdd from './SpecAdd';
import SpecEdit from './SpecEdit';
function SpecList() {      
    const [list, setList] = useState(); 
    const [query,setQuery] = useState()
    const {data, isSuccess} = useBnsGuiGeListQuery(query,{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bsg_id:key,bsg_name,bsg_ctime,bsg_cname,bsg_price,bsg_dept_id,bsg_dept_name,bsg_state,bsg_luyou,bsg_image,bsg_goods,bsg_bg_name,bg_id,bsg_bgn_name} = item;
                    return item = {key,bsg_name,bsg_ctime,bsg_cname,bsg_price,bsg_dept_id,bsg_dept_name,bsg_state,bsg_luyou,bsg_image,bsg_goods,bsg_bg_name,bg_id,bsg_bgn_name}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bsg_ctime;
                    let bTimeString = b.bsg_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    const columns = [
        {
            key: 'bsg_bg_name',
            title: '产品',
            dataIndex: 'bsg_bg_name',            
        }, 
        {
            key: 'bsg_bgn_name',
            title: '版本',
            dataIndex: 'bsg_bgn_name',            
        }, 
        {
            key: 'bsg_name',
            title: '规格名称',
            dataIndex: 'bsg_name',            
        },     
           
        {
            key: 'bsg_image',
            title: '图标',
            dataIndex: 'bsg_image',  
            render:(text) => {
                return <Image src={`/api/assets/images/application/${text}`} width={40}/>
            }          
        },     
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',           
        },
        {
            key: 'bsg_price',
            title: '价格',            
            dataIndex: 'bsg_price',           
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.bsg_ctime + record.bsg_cname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>  
                        <SpecEdit
                            bsg_id={record.key}
                        />
                        <ModalDel onOk={() => {
                            del({bsg_id:record.key}).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('删除成功！')                                                                              
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        }} />                              
                    </Space>
                </>
            }
        },
    ]   
    //删除
    const [del] = useBnsGuiGeDelMutation()
    return (
        <Main t1='软件开发' t2='规格'>  
            <Space size='large'>
                <SpecAdd/>
                <ProjectSelect
                    label='产品'
                    getProduct={(e) => {
                        setQuery(prevState=>({
                            ...prevState,
                            bsg_bg_id:e
                        }))
                    }}
                    FormStyle={{marginBottom:"0"}}
                />
                <Button
                    onClick={() => {
                        setQuery(prevState=>({
                            ...prevState,
                            bsg_bg_id:''
                        }))
                    }}
                >重置</Button>
            </Space>          
            <Table 
                columns={columns} 
                dataSource={list} 
                style={{marginTop:"20px"}}
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}}                 
            />
        </Main>
    )
}

export default SpecList